export const fileToBase64 = async (filePath: string): Promise<string> => {
  const response = await fetch(filePath);

  if (!response.ok) {
    return filePath;
  }

  const blobToBase64 = (blob: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const base64Image = await blobToBase64(await response.blob());

  if (!base64Image) {
    return filePath;
  }

  return `${base64Image}`;
};
